import { useState, useCallback } from "react";

export const useEvacuationSelections = () => {
  const [selectedMusterPoints, setSelectedMusterPoints] = useState<number[]>([]);
  const [selectedEventType, setSelectedEventType] = useState<number | null>(null);
  const [selectedWhoToInclude, setSelectedWhoToInclude] = useState<number[]>([]);

  const toggleMusterPoint = useCallback((pointId: number) => {
    setSelectedMusterPoints((prev) =>
      prev.includes(pointId)
        ? prev.filter((id) => id !== pointId)
        : [...prev, pointId]
    );
  }, []);

  const toggleEventType = useCallback((eventType: number) => {
    setSelectedEventType((prev) => prev === eventType ? null : eventType);
  }, []);

  const toggleWhoToInclude = useCallback((option: number) => {
    setSelectedWhoToInclude((prev) =>
      prev.includes(option)
        ? prev.filter((value) => value !== option)
        : [...prev, option]
    );
  }, []);

  const initializeWhoToInclude = useCallback((options: number[]) => {
    setSelectedWhoToInclude(options);
  }, []);

  const clearMusterPoints = useCallback(() => {
    setSelectedMusterPoints([]);
  }, []);

  return {
    selectedMusterPoints,
    selectedEventType,
    selectedWhoToInclude,
    toggleMusterPoint,
    toggleEventType,
    toggleWhoToInclude,
    initializeWhoToInclude,
    clearMusterPoints,
    setSelectedEventType,
    setSelectedMusterPoints,
  };
};